import { StoreAction, XmAction } from 'store/actions';
import { CmsNowCore, CmsNowDeviceDetails, CmsNowEsim, CmsNowLines, CmsNowModals, CmsNowMoreOptions, CmsNowNumberLock, CmsNowReturnExchange, CmsNowStepUpAuth } from './models';

export function cmsNowCoreReducer(state: CmsNowCore, action: XmAction<CmsNowCore>): CmsNowCore {
    return action.type === StoreAction.GET_NOW_CORE ? action.payload : state;
}

export function cmsNowLinesReducer(state: CmsNowLines, action: XmAction<CmsNowLines>): CmsNowLines {
    return action.type === StoreAction.GET_NOW_LINES ? action.payload : state;
}

export function cmsNowDeviceDetailsReducer(state: CmsNowDeviceDetails, action: XmAction<CmsNowDeviceDetails>): CmsNowDeviceDetails {
    return action.type === StoreAction.GET_NOW_DEVICE_DETAILS ? action.payload : state;
}

export function cmsNowModalsReducer(state: CmsNowModals, action: XmAction<CmsNowModals>): CmsNowModals {
    return action.type === StoreAction.GET_NOW_MODALS ? action.payload : state;
}

export function cmsNowMoreOptionsReducer(state: CmsNowMoreOptions, action: XmAction<CmsNowMoreOptions>): CmsNowMoreOptions {
    return action.type === StoreAction.GET_NOW_MORE_OPTIONS ? action.payload : state;
}

export function cmsNowNumberLockReducer(state: CmsNowNumberLock, action: XmAction<CmsNowNumberLock>): CmsNowNumberLock {
    return action.type === StoreAction.GET_NOW_NUMBER_LOCK ? action.payload : state;
}

export function cmsNowStepUpAuthReducer(state: CmsNowStepUpAuth, action: XmAction<CmsNowStepUpAuth>): CmsNowStepUpAuth {
    return action.type === StoreAction.GET_NOW_STEP_UP_AUTH ? action.payload : state;
}

export function cmsNowReturnExchangeReducer(state: CmsNowReturnExchange, action: XmAction<CmsNowReturnExchange>): CmsNowReturnExchange {
    return action.type === StoreAction.GET_NOW_RETURN_EXCHANGE ? action.payload : state;
}

export function cmsNowEsimReducer(state: CmsNowEsim, action: XmAction<CmsNowEsim>): CmsNowEsim {
    return action.type === StoreAction.GET_NOW_ESIM ? action.payload : state;
}
